import { render, staticRenderFns } from "./VueAvatarScale.vue?vue&type=template&id=86879932&"
import script from "./VueAvatarScale.vue?vue&type=script&lang=js&"
export * from "./VueAvatarScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports